import React from 'react';
import PropTypes from 'prop-types';
import { GlgTooltip } from '../../shared/components';

// Info circle carrying a hover message: the disposition cause (the DQ/WD/...
// reason entered on the scorecard) on dispositioned rows, and the
// display-options warning next to a tournament's name on the manager site.
// `content` is one string, or a list of strings rendered one per line.
// Renders nothing without content. The bubble keeps GlgTooltip's default
// placement - the message may open on any side, so no custom positioning is
// needed (react-bootstrap 0.32 could not auto-flip anyway).
const InfoTooltip = ({ content }) => {
  const lines = (Array.isArray(content) ? content : [content]).filter(Boolean);
  if (lines.length === 0) return null;

  const tooltip = lines.length === 1
    ? lines[0]
    : lines.map((line, idx) => <div key={idx}>{line}</div>);

  return (
    <GlgTooltip tooltip={tooltip}>
      <span className="lbv2__info-tooltip far fa-circle-info" />
    </GlgTooltip>
  );
};

InfoTooltip.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

export default InfoTooltip;
